import {HTTP, ERROR} from '@/http-common';
import Vue from 'vue';

const state = {
  settings: {},
  showLoading: true,
};

const mutations = {
  SET_GENERAL_SETTINGS(state, data) {
    state.settings = data;
  },
  SET_GENERAL_SETTINGS_LOADING(state, data) {
    state.showLoading = data;
  }
};

const getters = {
  getGeneralSettings: state => state.settings,
  getGeneralSettingsLoading: state => state.showLoading
};

const actions = {
  loadGeneralSettings: ({commit}) => {
    commit('SET_GENERAL_SETTINGS_LOADING', true);
    HTTP.get(`general-settings`)
      .then(response => {
        ERROR(response);
        if (response.status === 200) {
          commit('SET_GENERAL_SETTINGS', response.data.data);
          commit('SET_GENERAL_SETTINGS_LOADING', false);
        }
      }).catch(err => {
      console.log(err);
      commit('SET_GENERAL_SETTINGS_LOADING', false);
    })
  },
  saveGeneralSetting: ({commit}, payload) => {
    payload.context.start();
    HTTP.post(`general-settings/save`, {data: payload.data})
      .then(response => {
        ERROR(response);
        if (response.status === 200) {
          Vue.prototype.$notify(payload.message);
        }
        payload.context.stop();
      }).catch(err => {
      console.log(err);
      payload.context.stop();
    })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/generalSettings.js